import { SpinnerNamesEnum } from 'app/core/enums/ui/spinners';
import { ModalNamesEnum } from 'app/core/enums/ui/modals';

// State type
export interface UIState {
  idle: IdleState;
  spinners: SpinnersState;
  modals: ModalsState;
  announce: {
    visible: boolean;
  };
  isCalendarOpen: boolean;
  isMobileNavOpen: boolean;
}

interface IdleState {
  isTimeout: boolean;
}

interface SpinnersState {
  asyncSpinner: {
    count: number;
    visible: boolean;
  },
  paymentSpinner: {
    visible: boolean;
  }
}

interface ModalsState {
  idleModalVisible: boolean;
  memberLoginModalVisible: boolean;
  memberRegisterNSModalVisible: boolean;
  homeMainNewsContentModalVisible: boolean;
  homeTravelInsClaimDocumentsModalVisible: boolean;
  memberProfileLoginRecordModalVisible: boolean;
}
// ::: End

// Actions type constant
export const UI_IDLE__SET_IDLE_TIMEOUT_STATUS = 'UI_IDLE__SET_IDLE_TIMEOUT_STATUS';
export const UI_SPINNERS__SET_SPINNER_VISIBLE = 'UI_SPINNERS__SET_SPINNER_VISIBLE';
export const UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE = 'UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE';
export const UI_MODALS__SET_MODAL_VISIBLE = 'UI_MODALS__SET_MODAL_VISIBLE';
export const UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE = 'UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE';
export const UI_ANNOUNCE__VISIBLE = 'UI_ANNOUNCE__VISIBLE';
export const UI_IS_CALENDAR_OPEN = 'UI_IS_CALENDAR_OPEN';
export const UI_IS_MOBILE_NAV_OPEN = 'UI_IS_MOBILE_NAV_OPEN';
// ::: End

// Action creators type
export interface SetIdleTimeoutStatusAction {
  type: typeof UI_IDLE__SET_IDLE_TIMEOUT_STATUS;
  payload: {
    isTimeout: boolean;
  };
}

export interface SetSpinnerVisibleAction {
  type: typeof UI_SPINNERS__SET_SPINNER_VISIBLE;
  payload: {
    name: SpinnerNamesEnum;
    visible: boolean;
  };
}

export interface SetAsyncSpinnerVisibleAction {
  type: typeof UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE;
  payload: {
    isRequest: boolean;
  };
}

export interface SetModalVisibleAction {
  type: typeof UI_MODALS__SET_MODAL_VISIBLE;
  payload: {
    name: ModalNamesEnum;
    visible: boolean;
  };
}

export interface SetPaymentVisibleAction {
  type: typeof UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE;
  payload: {
    visible: boolean;
  };
}

export interface SetAnnounceVisibleAction {
  type: typeof UI_ANNOUNCE__VISIBLE;
  payload: {
    visible: boolean;
  };
}

export interface SetIsCalendarOpenAction {
  type: typeof UI_IS_CALENDAR_OPEN;
  payload: {
    isCalendarOpen: boolean;
  };
}

export interface SetIsMobileNavOpenAction {
  type: typeof UI_IS_MOBILE_NAV_OPEN;
  payload: {
    isMobileNavOpen: boolean;
  };
}

export type UIActions =
    SetIdleTimeoutStatusAction
  | SetSpinnerVisibleAction
  | SetAsyncSpinnerVisibleAction
  | SetModalVisibleAction
  | SetPaymentVisibleAction
  | SetAnnounceVisibleAction
  | SetIsCalendarOpenAction
  | SetIsMobileNavOpenAction;
// ::: End
